import React from "react";
import styles from "./edit-machine-name.module.scss";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import { RenderIfUserHasPermission } from "../render-if-user-has-permission/render-if-user-has-permission";
import renameIcon from "@src/assets/svg/rename-blue-icon.svg";
import saveIcon from "@src/assets/svg/save-right-blue-icon.svg";
import closeIcon from "@src/assets/svg/close-orange-icon.svg";
import {
  EditableMachineName,
  useEditMachineNameHook,
} from "./use-edit-machine-name-hook";

interface EditMachineNameProps {
  machine: EditableMachineName;
}

const cssClassName = "edit-machine-name";

export const EditMachineName = ({ machine }: EditMachineNameProps) => {
  const {
    showInput,
    newMachineName,
    isSaving,
    texts,
    editMachineName,
    updateNewMachineName,
    saveMachineName,
    cancelEdit,
    onKeyDown,
  } = useEditMachineNameHook(machine);

  return (
    <span className={styles[cssClassName]}>
      {!showInput && (
        <span className={styles[`${cssClassName}__item-name-wrapper`]}>
          <span className={styles[`${cssClassName}__item-name`]}>
            {newMachineName || machine.name}
          </span>
          <RenderIfUserHasPermission permission="manage-sources">
            <span className={styles[`${cssClassName}__edit-text-button`]}>
              <IconButton
                fun={editMachineName}
                icon={renameIcon}
                tooltip={texts.edit}
                variant="edit-save-close-icon"
              />
            </span>
          </RenderIfUserHasPermission>
        </span>
      )}
      {showInput && (
        <>
          <span className={styles[`${cssClassName}__item-name-input-wrapper`]}>
            <input
              type="text"
              value={newMachineName}
              disabled={isSaving}
              onClick={(event) => event.stopPropagation()}
              onChange={updateNewMachineName}
              onKeyDown={onKeyDown}
              className={styles[`${cssClassName}__item-name-input`]}
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus
            />
          </span>
          <div className={styles[`${cssClassName}__buttons-wrapper`]}>
            <span className={styles[`${cssClassName}__save-text-button`]}>
              <IconButton
                fun={saveMachineName}
                icon={saveIcon}
                tooltip={texts.save}
                disabled={isSaving}
                variant="edit-save-close-icon"
              />
            </span>
            <span className={styles[`${cssClassName}__cancel-text-button`]}>
              <IconButton
                fun={cancelEdit}
                icon={closeIcon}
                tooltip={texts.cancel}
                disabled={isSaving}
                variant="edit-save-close-icon"
              />
            </span>
          </div>
        </>
      )}
    </span>
  );
};
